export const GroupUserReportColumns = () => [
  { title: "Employee Id", dataIndex: "username", key: "username", width: 150 },
  { title: "Name", dataIndex: "fullName", key: "fullName", width: 150 },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: 250,
    ellipsis: true,
    render: (text) => (
      <div style={{ maxWidth: 250, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={text}>
        {text}
      </div>
    ),
  },
  { title: "Role", dataIndex: "role", key: "role", width: 150 },
  {
    title: "Manager",
    dataIndex: "manager",
    key: "manager",
    width: 150,
    ellipsis: true,
    render: (text) => (
      <div style={{ maxWidth: 150, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={text}>
        {text}
      </div>
    ),
  },
  { title: "Assigned Courses", dataIndex: "uniqueAssignedCourses", key: "assignedCourses", width: 150 },
  { title: "Completed Courses", dataIndex: "completedCourses", key: "completedCourses", width: 150 },
  { title: "In Progress Courses", dataIndex: "inProgressCourses", key: "inProgressCourses", width: 160 },
  { title: "Not Started Courses", dataIndex: "notStartedCourses", key: "notStartedCourses", width: 160 },
  { title: "Courses Completed On Time", dataIndex: "onTimeCourses", key: "onTimeCourses", width: 180 },
  { title: "Courses Completed Late", dataIndex: "lateCourses", key: "lateCourses", width: 180 },
  { title: "On Track Courses", dataIndex: "onTrackCourses", key: "onTrackCourses", width: 150 },
  { title: "Behind Schedule Courses", dataIndex: "behindScheduleCourses", key: "behindScheduleCourses", width: 180 },
  { title: "Courses Not Due Yet", dataIndex: "notDueYetCourses", key: "notDueYetCourses", width: 160 },
  { title: "No Deadline Courses", dataIndex: "noDeadlineCourses", key: "noDeadlineCourses", width: 140 },
];